import { render } from "./RiGridViewNew.vue?vue&type=template&id=90a32750"
import script from "./RiGridViewNew.vue?vue&type=script&lang=js"
export * from "./RiGridViewNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiGridViewNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90a32750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90a32750', __exports__)) {
    api.reload('90a32750', __exports__)
  }
  
  module.hot.accept("./RiGridViewNew.vue?vue&type=template&id=90a32750", () => {
    api.rerender('90a32750', render)
  })

}


export default __exports__